import apiService from "../common/commonApi";

export const addNewProject  = {};

addNewProject.list = async (param) => {    
    return apiService.Get('addnewproject-list', param);
}

